import React from 'react';

import styles from './PromoItem.module.scss';

export const PromoItem: React.FC = () => {
  return (
    <div className={styles.promoitem}>
      <h4>Access to online yoga, fitness classes and guided meditation.</h4>
      <div className={styles.promoitem__logo}>Yogaia</div>
    </div>
  );
};
